module.exports = __webpack_public_path__ + "img/weddings_02_V.ccf6137b.webp";